export default "__VITE_ASSET__1QH2DJf0__"